import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-009e9ab4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "m-logo" }
const _hoisted_2 = { class: "caution-note" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("テストはこれで"),
  /*#__PURE__*/_createElementVNode("ruby", null, [
    /*#__PURE__*/_createTextVNode("終"),
    /*#__PURE__*/_createElementVNode("rp", null, "（"),
    /*#__PURE__*/_createElementVNode("rt", null, "お"),
    /*#__PURE__*/_createElementVNode("rp", null, "）")
  ]),
  /*#__PURE__*/_createTextVNode("わりです。")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "よくがんばりました。", -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("先生"),
  /*#__PURE__*/_createElementVNode("rt", null, "せんせい")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("言"),
  /*#__PURE__*/_createElementVNode("rt", null, "い")
], -1))
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("席"),
  /*#__PURE__*/_createElementVNode("rt", null, "せき")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("離"),
  /*#__PURE__*/_createElementVNode("rt", null, "はな")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("静"),
  /*#__PURE__*/_createElementVNode("rt", null, "しず")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("座"),
  /*#__PURE__*/_createElementVNode("rt", null, "すわ")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("待"),
  /*#__PURE__*/_createElementVNode("rt", null, "ま")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("画面"),
  /*#__PURE__*/_createElementVNode("rt", null, "がめん")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("閉"),
  /*#__PURE__*/_createElementVNode("rt", null, "と")
], -1))
const _hoisted_16 = { class: "end-modal" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "ログイン画面へ戻りますか？", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "キャンセル", -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "OK", -1))
const _hoisted_21 = [
  _hoisted_20
]

import {inject, ref} from "vue"
import Modal from '@/components/parts/Modal.vue'
import { useRoute } from 'vue-router'
import { examKey } from "@/main";
import router from "@/router";
import DemoControl from "@/components/parts/DemoControl.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'End',
  emits: ['overridePageName'],
  setup(__props) {

const exam = inject(examKey);


const route = useRoute();

const group = route.params.group;
const visibleEndModal = ref(false);
const clickCount = ref(0);

const clickLogo = () => {
  clickCount.value++;
  if (clickCount.value >= 8) {
    visibleEndModal.value = true;
    clickCount.value = 0;
  }
  else if (clickCount.value == 1) {
    setTimeout(function () {
      clickCount.value = 0;
    }, 2000);
  }
}

const toLogin = () => {
  router.replace(`/cbt/${group}/login`);
}

const closeWindow = () => {
  exam?.endFullScreen();
  window.close();
  toLogin();
}

const gakken = exam?.isGakken();

const demoPrev = () => router.replace(`/cbt/${group}/start`);
const demoNext = () => router.replace(`/cbt/${group}/exam-start`);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: "/assets/img/logo-small.svg",
        alt: "jpt",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (clickLogo()))
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      (!_unref(gakken))
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
            _hoisted_6,
            _createTextVNode("が、よろしいと"),
            _hoisted_7,
            _createTextVNode("うまで、")
          ]))
        : _createCommentVNode("", true),
      (!_unref(gakken))
        ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
            _hoisted_9,
            _createTextVNode("を"),
            _hoisted_10,
            _createTextVNode("れずに"),
            _hoisted_11,
            _createTextVNode("かに"),
            _hoisted_12,
            _createTextVNode("って"),
            _hoisted_13,
            _createTextVNode("ちましょう。")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("p", {
        class: _normalizeClass(["close-window", {gakken: _unref(gakken)}])
      }, [
        _createElementVNode("a", { onClick: closeWindow }, [
          _createTextVNode("この"),
          _hoisted_14,
          _createTextVNode("を"),
          _hoisted_15,
          _createTextVNode("じる")
        ])
      ], 2)
    ]),
    _createVNode(Modal, {
      visible: visibleEndModal.value,
      onClose: _cache[3] || (_cache[3] = ($event: any) => (visibleEndModal.value = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("div", null, [
            _createElementVNode("a", {
              onClick: _cache[1] || (_cache[1] = () => {visibleEndModal.value = false}),
              class: "m-btn is-center"
            }, _hoisted_19),
            _createElementVNode("a", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (toLogin())),
              class: "m-btn is-center"
            }, _hoisted_21)
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(DemoControl, {
      onPrev: demoPrev,
      onNext: demoNext,
      prev: false,
      next: false
    })
  ], 64))
}
}

})